import { products } from "../data/products";
import "../styles/products.css";

export default function ProductShowcase() {
    return (
        <section className="products-section fadeInUp">

            <h2 className="products-title section-heading">
                Our Premium Range
            </h2>
            <div className="products-grid">
                {products.map((item, index) => (
                    <div className="product-float" key={index}>
                        <img
                            src={item.img}
                            alt={item.name}
                            width="210"
                            height="210"
                        />
                        <span className="product-type">
                            {item.type}
                        </span>
                        <h4>{item.name}</h4>
                    </div>
                ))}
            </div>

        </section>
    );
}
